import { ListItemGraphic } from 'lib/list';
import styled from 'styled-components';

const ContextMenuListItemGraphic = styled(ListItemGraphic)``;

export { ContextMenuListItemGraphic };
